import React from 'react';
import PropTypes from 'prop-types';

import { FormFieldContext, FormTextField } from '@metarouter-private/mr-mui';

import sanitizeTagLabel from 'app/shared/helpers/tags/sanitizeTagLabel';
import useValidateUniqueLabel from './useValidateUniqueLabel';

export default function TagLabelField({ defaultValue, excludeLabel }) {
  const validateUniqueLabel = useValidateUniqueLabel({ excludeLabel });

  return (
    <FormFieldContext
      name="label"
      label="Label"
      required
      defaultValue={defaultValue}
      rules={{ validate: validateUniqueLabel }}
    >
      <FormTextField variant="outlined" inputTransform={sanitizeTagLabel} />
    </FormFieldContext>
  );
}

TagLabelField.propTypes = {
  defaultValue: PropTypes.string,
  excludeLabel: PropTypes.string,
};
